<template>
  <button @click="exportHistory" class="btn btn-primary mr-1">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop no-enforce-focus>
      <div class="alert alert-warning">
        <span>{{ $t('exportNotice') }}</span>
      </div>
      <div class="text-center">
        <b-spinner></b-spinner>
      </div>
    </b-modal>
  </button>
</template>

<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';

export default {
  props: ['data'],
  data() {
    return {
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0
    }
  },
  methods: {
    exportHistory: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      this.setupSheet(sheet);
      this.data.forEach(item => {
          let row = item;
          row.companyName = item.client.companyName;
          row.domain = item.client.domain;
          row.gateway = `${item.gateway.name} (${item.gateway.fee})`;
          row.template = item.template.name;
          if (item.sendTime && item.chargeTime) {
            row.status = this.$t('charged');
          } else if (item.sendTime) {
            row.status = this.$t('sent');
          } else {
            row.status = this.$t('waiting');
          }
          sheet.addRow(row);
          this.downloadedCount += 1;
        });
      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        this.exporting = false;
        saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'auto-call-history.xlsx');
      }).finally(() => {
        this.cancelRequest = false;
        this.downloadedCount = 0;
      });
    },
    setupSheet: function (sheet) {
      sheet.columns = [
        {header: this.$t('companyName'), key: 'companyName', width: 15},
        {header: this.$t('domain'), key: 'domain', width: 15},
        {header: this.$t('gateway'), key: 'gateway', width: 15},
        {header: this.$t('template'), key: 'template', width: 15},
        {header: this.$t('phone'), key: 'phone', width: 15},
        {header: this.$t('chargedFee'), key: 'chargedFee', width: 15},
        {header: this.$t('status'), key: 'status', width: 15},
      ];
    },
    close() {
      this.cancelRequest = true;
    }
  },
  i18n: {
    messages: {
      en: {
        waiting: "Waiting",
        sent: "Sent",
        charged: "Charged",
        chargedFee: "Charged fee",
        template: "Template",
        phone: "Phone",
      },
      vi: {
        waiting: "Đang đợi",
        sent: "Đã gửi",
        charged: "Đã thu phí",
        chargedFee: "Phí cuộc gọi",
        template: "Mẫu cuộc gọi",
        phone: "Số gọi đến",
      }
    }
  }
}
</script>
